import { createContext } from "react";

/** Limit the bottom dissolve to the tab connected to a surrounding card. */
export const StickyAccordionBottomFadeContext = createContext<{
  gap: number;
  side: "full" | "left" | "right";
}>({ gap: 0, side: "full" });
